import React from 'react';

import {Sequence} from 'components/Sequence';
import {CRISPRAnalysis} from 'constants/CRISPRConstants';
import SearchDNAData from 'molbio/biological-search/SearchDNAData';
import Modal from 'ui-library/modals/Modal';

// @ts-expect-error
import CRISPRAnalysisActions from './CRISPRAnalysisActions';
import SetDefaultsInput from './SetDefaultsInput';
// @ts-expect-error
import SettingsForm from './SettingsForm';

interface Props {
  allowEdits: boolean;
  analysis: CRISPRAnalysis;
  analysisLoading: boolean;
  onRequestClose: () => void;
  findGuidesParams: {
    search: SearchDNAData;
    sequence: Sequence;
  };
}

interface State {
  submitted: boolean;
  formValidated: boolean;
}

class SettingsModal extends React.Component<Props, State> {
  override state: State = {
    submitted: false,
    formValidated: true,
  };

  settingsFormRef = React.createRef<SettingsForm>();
  setDefaultsInputRef = React.createRef<SetDefaultsInput>();

  override UNSAFE_componentWillReceiveProps(nextProps: Props): void {
    if (this.isSaving() && !nextProps.analysisLoading) {
      this.props.onRequestClose();
    }
  }

  setValid = (valid: boolean): void => {
    this.setState({formValidated: valid});
  };

  isSaving = (): boolean => this.state.submitted && this.props.analysisLoading;

  save = (): void => {
    const settings = this.settingsFormRef.current.getChangedAnalysisSettings();
    // If the user submits the form without changing anything, still want to be able to set as defaults.
    this.setDefaultsInputRef.current!.setDefaults(this.settingsFormRef.current.getAllSettings());
    CRISPRAnalysisActions.update(this.props.analysis.id, settings, this.props.findGuidesParams);
    this.setState({submitted: true});
  };

  override render(): JSX.Element {
    return (
      <Modal
        title={`CRISPR analysis settings${this.props.allowEdits ? '' : ' (read-only)'}`}
        onRequestSubmit={this.save}
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            text: this.isSaving() ? 'Saving...' : 'Save',
            submit: true,
            disabled: this.isSaving() || !this.state.formValidated || !this.props.allowEdits,
          },
        ]}
        footer={React.createElement(SetDefaultsInput, {
          disabled: !this.props.allowEdits,
          initialShouldSetDefaults: false,
          ref: this.setDefaultsInputRef,
        })}
        dataTestAttrs={{component: 'SettingModal', element: 'modal'}}
      >
        <SettingsForm
          allowEdits={this.props.allowEdits}
          analysis={this.props.analysis}
          setValid={this.setValid}
          ref={this.settingsFormRef}
        />
      </Modal>
    );
  }
}

export default SettingsModal;
